import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WeissmanModalService } from '../../../Compliance/WeissmanModalService';
import { UtilitiesService } from '../../../UI-Lib/Utilities';
import { UserGroupModalComponent } from '../../../User-Group/Modal/userGroupModal.component';
import { UserGroupService } from '../../../User-Group/user-group-service.upgrade';

@Component({
    selector: 'user-group-panel',
    templateUrl: './userGroupPanel.component.html',
    standalone: false
})
export class UserGroupPanelComponent implements OnInit {
    constructor(private readonly _userGroupService: UserGroupService,
                private readonly _weissmanModalService: WeissmanModalService,
                private readonly _utils: UtilitiesService) { }

    @Input() canEdit: boolean;
    @Input() assignedGroups: any[];
    @Input() instanceId: number;

    @Output() assignedGroupsChange = new EventEmitter<any[]>();

    userGroupToAdd = null;
    availableGroups = [];
    hasUsersEdit = true; //userService.isInRole(Roles.USERSEDIT);
    hasUsersViewOrEdit = true; //!userService.isNotInRoles([Roles.USERSVIEW, Roles.USERSEDIT]);

    nonDeletedFilter = (item): boolean => {
        return item.efAction !== 'delete';
    };

    assignedUserGroups = (group): boolean => {
        const groupInAssignedGroups = this.assignedGroups.find( x => x.groupID === group.groupID);

        if (groupInAssignedGroups) {
            return groupInAssignedGroups.efAction === 'delete';
        } else {
            return true;
        }
    }

    async ngOnInit(): Promise<void> {
        this.availableGroups = await this._userGroupService.get(this.instanceId);
    }

    selectUserGroupToAdd(): void {
        this.userGroupToAdd = {};
    }

    cancelAddUserGroup(): void {
        this.userGroupToAdd = null;
    }

    addUserGroup(): void {
        const foundAssignedGroup = this.assignedGroups.find(x => x.groupID === this.userGroupToAdd.groupID);

        if (foundAssignedGroup) {
            foundAssignedGroup.efAction = null;
        } else {
            this.userGroupToAdd.efAction = 'add';
            this.assignedGroups = [...this.assignedGroups, this.userGroupToAdd];
            this.assignedGroupsChange.emit(this.assignedGroups);
        }

        this.cancelAddUserGroup();
    }

    deleteUserGroup(group): void {
        if (group.efAction === 'add') {
            this.assignedGroups.splice(this.assignedGroups.indexOf(group), 1);
        } else {
            group.efAction = 'delete';
        }
        this.assignedGroups = [...this.assignedGroups];
        this.assignedGroupsChange.emit(this.assignedGroups);
    }

    async editUserGroup(group): Promise<void> {
        const params = {
            userGroup: group,
            readOnly: true,
            editMode: false
        }
        await this._weissmanModalService.showAsync(UserGroupModalComponent, params, 'modal-lg');
    }
}
